// extracted by mini-css-extract-plugin
export default {"btnOrange":"Teacher_btnOrange__rappm"};